<template>
    <div>
        <!--圆环-->
        <div v-if="type == 've-ring'">
            <ve-ring
                    :data="chartData"
                    :colors="ringChart.colors"
                    :tooltip-visible="false"
                    :settings="ringChart.settings"
                    :legend="ringChart.legend"
                    width="400px"
                    height="300px"
                    :extend="ringChart.chartExtend"
            ></ve-ring>
        </div>
        <!--堆叠柱状图-->
        <div v-if="type == 've-histogram'">
            <ve-histogram
                    :data="chartData"
                    :colors="histogram.colors"
                    :tooltip-visible="false"
                    :settings="histogram.settings"
                    :legend="histogram.legend"
                    :extend="histogram.chartExtend"
            ></ve-histogram>
        </div>
        <!--普通柱状图-->
        <div v-if="type == 've-histogram-default'">
            <ve-histogram
                    :data="chartData"
                    :colors="histogramDefault.colors"
                    :tooltip-visible="false"
                    :settings="histogramDefault.settings"
                    :legend="histogramDefault.legend"
                    :extend="histogramDefault.chartExtend"
            ></ve-histogram>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'chartsPage',
        props: {
//            展示信息
            chartData: Object,
//            图标类型
            type:String,
        },
        data() {
            return {
//                环形图配置
                ringChart: {
                    // 环形图颜色
                    colors: ["rgb(138,199,247)","rgb(231,233,234)"],
                    //通过extend属性实现对已配置好的内部属性进行单独的设置,即可以覆盖默认的值
                    chartExtend: {
                        tooltip:{
                            show:false,
                        },
                        graphic: { //环形图中间添加文字
                            type: 'text', //通过不同top值可以设置上下显示
                            left: 'center',
                            top: '45%',
                            style: {
                                text: '53%'+'\n'+'Reading',
                                textAlign: 'center',
                                fill: '#777777', //文字的颜色
                                width: 30,
                                height: 30,
                                fontSize: 20,
                                fontFamily: "Microsoft YaHei"
                            }
                        },
                        series: {
                            center: [200, 150],
                            label:{
                                normal: {
                                    show:false,
                                },
                                emphasis:{
                                    show:false,
                                }
                            }
                        },
                    },
                    //配置项
                    settings: {
                        //如图1
                        label: {
                            show: false,
                        },
                        //hover的时候是否变大
                        hoverAnimation: false,
                        // 环图 -- 内外径
                        radius: [70, 100]

                    },
                    //如图2
                    legend: {
                        show: false
                    },
                },
//                堆叠柱状图配置
                histogram: {
                    colors: ["rgb(138,199,247)","rgb(231,233,234)"],
                    chartExtend: {
                        tooltip:{
                            show:false,
                        },
                        stack: { 'name': ['value', 'all']},
                        series: {
                            barWidth:150
                        },
                    },
                    //配置项
                    settings: {
                        label: {
                            show: false,
                        },
                        //hover的时候是否变大
                        hoverAnimation: false,

                    },
                    legend: {
                        show: true,
                        bottom:'bottom'
                    },
                },
                histogramDefault: {
                    colors: ["rgb(227,237,169)","rgb(197,221,124)","rgb(227,237,169)"],
                    chartExtend: {
                        tooltip:{
                            show:false,
                        },

                        series: {
                            barWidth:100,
                        },

                    },
                    //配置项
                    settings: {
                        label: {
                            show: false,
                        },
                        //hover的时候是否变大
                        hoverAnimation: false,
                        max:'100%',
                        yAxisType: ['percent'],

                    },
                    legend: {
                        show: false,
                    },
                }

            };
        },
        computed: {
        },
        created() {
            if(this.type == 've-ring') {
                var a = this.chartData.rows[0].Reading
                var b = this.chartData.rows[0].value
                this.ringChart.chartExtend.graphic.style.text = b + '%' + '\n' + a

            }
        },
        mounted() {

        },
        methods: {

        }
    }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
